import { createContext, useContext } from 'react';

export const AuthContext = createContext({
  token: null,
  error: null,
  expiration: null
});

export const useAuthContext = () => useContext(AuthContext);
